import React from "react";
import FooterOne from "../components/footers/FooterOne";
import NeedHelp from "../features/common/NeedHelp";
import AllDemos from "../features/overview/AllDemos";
import { Link } from "react-router-dom";

const Overview = () => {
  return (
    <>
      <section className="md:pt-[174px] pt-[120px] pb-[90px] md:pb-[130px] bg-cover bg-right-bottom md:bg-center bg-[url('../images/overview.png')] bg-white">
        <div className="container">
          <div className="grid grid-cols-1">
            <div className="max-w-[890px] mx-auto">
              <h1 className="font-bold text-center leading-[1.4] text-3xl md:text-[40px]">
                Welcome to <span className="text-custom">Landik</span> Tailwind
                CSS Multipurpose Landing Page Template.
              </h1>
              <p className="text-muted mx-auto text-center mt-6 md:mt-12 text-xl max-w-[400px]">
                Build your website in minutes with the help of countless amazing
                features of Landik.
              </p>
              <div className="text-center flex justify-center mt-6 md:mt-12">
                <a href="#demo" className="text-muted items-center flex">
                  <i className="mdi mdi-arrow-down text-[26px] h-[50px] w-[50px] leading-[50px] border border-[#e9e9e9] text-custom rounded-full mr-4"></i>
                  View Demo
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <AllDemos />
      <NeedHelp />
      <FooterOne />
    </>
  );
};

export default Overview;
